function init() {
    var components = ['header', 'footer', 'block-breadcrumbs', 'backlink'];
    var url_params = new URLSearchParams(window.location.search);
    var myParam = url_params.get('format'); 
    if (myParam != null && myParam == 'app') {
        if (getCookie("format") == "") {
            setCookie("format", "app");
        }
    }
    if (getCookie("format") != "") {
        setAppStyle(components);
    }
}
function existElement(elem) {
    var v = document.querySelector('#' + elem);
    if (v != null)
        return true;
    else
        return false;
}
function setAppStyle(comp) {
    comp.forEach(element => {
        if (existElement(element)) {
            var temp = document.querySelector('#' + element);
            temp.style.display = 'none';
        }
    });
}
function setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";domain=" + window.location.hostname + ";path=/;secure;";
}
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
window.addEventListener('DOMContentLoaded', init);
